import React from "react";
import { notification } from "../../utils/Notifications.tsx";
import Loader from "../Loader.tsx";
import { deleteDeduction } from "../../services/deductions.service.ts";

interface DeleteDeductionModalProps {
  closeFn: () => void;
  deduction: any;
  onSuccess: () => void;
}

const DeleteDeductionModal: React.FC<DeleteDeductionModalProps> = ({
  closeFn,
  deduction,
  onSuccess,
}) => {
  const [loading, setLoading] = React.useState(false);

  const handleDelete = async () => {
    if (!deduction?.id) {
      notification(
        "Error ⚠️",
        "No se encontró la deducción a eliminar",
        "danger"
      );
      return;
    }

    setLoading(true);
    try {
      await deleteDeduction(deduction.id);
      notification("", "Deducción eliminada exitosamente", "success");
      onSuccess();
      closeFn();
    } catch (error) {
      console.error("Error deleting deduction:", error);
      notification("Error ⚠️", "Error al eliminar la deducción", "danger");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Loader isLoading={loading} />

      <div className="alert alert-warning" role="alert">
        <i className="fa fa-exclamation-triangle me-2"></i>
        <strong>¿Estás seguro?</strong> Esta acción no se puede deshacer.
      </div>

      <div className="mb-3">
        <h6>Información de la deducción:</h6>
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <strong>Nombre:</strong> {deduction?.name || "-"}
              </div>
              <div className="col-md-6">
                <strong>Monto:</strong> ${deduction?.amount || 0}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-6">
                <strong>Colaborador:</strong>{" "}
                {deduction?.partner?.person?.firstName}{" "}
                {deduction?.partner?.person?.lastName}
              </div>
              <div className="col-md-6">
                <strong>Frecuencia:</strong> {deduction?.frequency || "-"}
              </div>
            </div>
            {deduction?.description && (
              <div className="row mt-2">
                <div className="col-12">
                  <strong>Descripción:</strong> {deduction.description}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end">
        <button
          className="btn btn-secondary me-2"
          onClick={closeFn}
          disabled={loading}
        >
          Cancelar
        </button>
        <button
          className="btn btn-danger"
          onClick={handleDelete}
          disabled={loading}
        >
          <i className="fa fa-trash me-1"></i>
          Eliminar deducción
        </button>
      </div>
    </div>
  );
};

export default DeleteDeductionModal;
